import React, { Component } from "react";
import "./ColorCodeDropdown.scss";
import Dropdown from "react-bootstrap/Dropdown";
import ArrowDown from "../../assets/icons/arrows/chevron-down.svg";

class ColorCodeDropdown extends Component {
  state = {
    selectedColor: this.props.folderColor,
  };

  colorCodeButton = React.forwardRef(({ onClick }, ref) => (
    <button
      className="btn-dropdown btn-location-dropdown mr-2s"
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      <div>
        {this.state.selectedColor ? (
          <div div className="color-code-item">
            <div
              className="color-code"
              style={{ backgroundColor: this.state.selectedColor.colorCode }}
            ></div>
            {this.state.selectedColor.label}
          </div>
        ) : (
          "Select color code"
        )}
      </div>
      <img
        className="ml-1 mr-0"
        width="20"
        height="20"
        src={ArrowDown}
        alt="arrowDown"
      />
    </button>
  ));

  handleColorCodeClick = (colorObj) => {
    this.setState({ selectedColor: colorObj });
    this.props.handleColorCodeClick(colorObj);
  };

  componentDidUpdate(prevProps) {
    if (this.props.folderColor !== prevProps.folderColor) {
      this.setState({ selectedColor: this.props.folderColor });
    }
  }

  render() {
    return (
      <div className="color-code-wrapper">
        <Dropdown
          alignRight
          direction="down"
          className={[
            "location-dropdown",
            this.props.editFolder ? "handle-width" : "ml-auto",
          ].join(" ")}
        >
          <Dropdown.Toggle as={this.colorCodeButton}></Dropdown.Toggle>
          <Dropdown.Menu>
            {this.props.colorCodes.map((colorObj, index) => (
              <Dropdown.Item
                as="a"
                key={index}
                onClick={() => this.handleColorCodeClick(colorObj)}
              >
                <div className="color-code-item">
                  <div
                    className="color-code"
                    style={{ backgroundColor: colorObj.colorCode }}
                  ></div>
                  {colorObj.label}
                </div>
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  }
}

export default ColorCodeDropdown;
